import { NormalizeOAS, OASResponse } from 'fets';
import type openapi from '../openapi';
import { ApiClient } from '../fetsClient';
import { assertNever } from '../utils';

type Params = {
  progressTrackingId: number;
  status: string;
};

export type ApiFunction = (params: Params, signal?: AbortSignal) => Promise<void>;

export const createSetCompletionStatus = (apiClient: ApiClient): ApiFunction => {
  const setCompletionStatus = async (params: Params, signal?: AbortSignal): Promise<void> => {
    const response = await apiClient['/api/progress-tracking/SetCompleted/{progressTrackingId}'].post({
      params: { progressTrackingId: params.progressTrackingId },
      json: params.status,
      ...(signal && { signal }),
    });

    return convertResponse(response);
  };

  return setCompletionStatus;
};

type Response = OASResponse<
  NormalizeOAS<typeof openapi>,
  '/api/progress-tracking/SetCompleted/{progressTrackingId}',
  'post'
>;

const convertResponse = async (response: Response): Promise<void> => {
  const responseStatus = response.status;
  if (responseStatus !== 200) {
    return assertNever(responseStatus);
  }
};
